import { render, staticRenderFns } from "./MyQuote.vue?vue&type=template&id=bb867cac&lang=html&"
import script from "./MyQuote.vue?vue&type=script&lang=js&"
export * from "./MyQuote.vue?vue&type=script&lang=js&"
import style0 from "./MyQuote.vue?vue&type=style&index=0&id=bb867cac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports